import { useState } from "react";
import { Link } from "react-router-dom";

export default function Contact() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState("");

    const CONTACT_URL =
        "https://us-central1-figure-it-out-app.cloudfunctions.net/contact";

    async function handleSubmit(e) {
        e.preventDefault();

        setSending(true);
        setStatus("");

        try {

            const response = await fetch(CONTACT_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name,
                    email,
                    message
                })
            });

            if (!response.ok) {
                throw new Error();
            }

            setStatus("Thank you! Your message has been sent.");

            setName("");
            setEmail("");
            setMessage("");

        } catch {

            setStatus("Sorry, something went wrong.");

        }

        setSending(false);
    }

    return (
        <div style={{ padding: "2rem" }}>
            <Link to="/" className="safe-top-link">
                ← Home
            </Link>

            <h1>Contact</h1>

            <p>
                Questions, feedback or suggestions?
            </p>

            <form onSubmit={handleSubmit}>

                <div style={{ marginBottom: "20px" }}>
                    <label
                        htmlFor="contact-name"
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: 600
                        }}
                    >
                        Name
                    </label>

                    <input
                        id="contact-name"
                        type="text"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>

                <br />

                <div style={{ marginBottom: "20px" }}>
                    <label
                        htmlFor="contact-email"
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: 600
                        }}
                    >
                        Email
                    </label>

                    <input
                        id="contact-email"
                        type="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>

                <br />

                <div style={{ marginBottom: "20px" }}>
                    <label
                        htmlFor="contact-message"
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: 600
                        }}
                    >
                        Message
                    </label>

                    <textarea
                        id="contact-message"
                        rows="6"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    />
                </div>

                <br />

                <button
                    type="submit"
                    disabled={sending}
                >
                    {sending ? "Sending..." : "Send Message"}
                </button>

            </form>

            {status && (
                <p>{status}</p>
            )}
        </div>
    );
}